module.exports = __webpack_public_path__ + "media/images/flags/MZ-4a331b45f99f796b8ec0d752263952b5.svg";